<template>
  <div>
    <BaseButton primary @click="createPerson"> New Contact Request </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    createPerson() {
      this.$modal.show({
        component: 'AccountPersonCreateModal',
        props: {
          accountId: this.accountId,
        },
        on: {
          created: (personId) => {
            this.$emit('created', personId);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
